// src/stores/featureStore.js

import { reactive, provide, inject } from 'vue';

const apiProxyUrl = process.env.VUE_APP_API_PROXY_URL;

export const createFeatureStore = () => {
  const state = reactive({
    featureInstances: [],
  });

  // Fetch creator’s active feature INSTANCES (not templates)
  const fetchFeatureInstances = async () => {
    try {
      const response = await fetch(`${apiProxyUrl}/api/feature-instances`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch feature instances: ${response.status}`);
      }

      const data = await response.json();
      state.featureInstances = data.instances;
    } catch (error) {
      console.error('Error fetching feature instances:', error);
    }
  };

  const updateFeatureName = async (instanceId, newName) => {
    const response = await fetch(
      `${apiProxyUrl}/api/feature-instances/${instanceId}/name`,
      {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customName: newName })
      }
    );

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload?.message || "The feature name could not be saved.");

    await fetchFeatureInstances();
    return payload;
  };

  return { state, fetchFeatureInstances, updateFeatureName };
};



export const provideFeatureStore = () => provide('featureStore', createFeatureStore());
export const useFeatureStore = () => {
  const store = inject('featureStore');
  if (!store) {
    throw new Error('Feature store not provided');
  }
  return store;
};

